(function () {
  console.log("[invoice] invoice-request.js loaded", window.location.pathname);

  const ENDPOINT =
    "https://ford-bikes-shopify-invoice-endpoint.jasonnplus.workers.dev/draft-order";

  function $(id) {
    return document.getElementById(id);
  }

  function ensureModalAtBody() {
    const overlay = $("invoiceModalOverlay");
    const modal = $("invoiceModal");
    if (!overlay || !modal) {
      console.warn("[invoice] modal elements not found", {
        overlay: !!overlay,
        modal: !!modal,
      });
      return;
    }
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureModalAtBody);
  } else {
    ensureModalAtBody();
  }

  function getSelectedVariantId() {
    // Most reliable: product form hidden input name="id"
    const productForm = document.querySelector('form[action^="/cart/add"]');
    const v = productForm?.querySelector('input[name="id"]')?.value;
    if (v) return v;

    // Fallbacks
    const dataEl = document.querySelector("[data-variant-id]");
    const dataV = dataEl?.getAttribute("data-variant-id");
    if (dataV) return dataV;

    const selectedOption = document.querySelector('select[name="id"] option:checked');
    return selectedOption?.value || null;
  }

  function openModal() {
    console.log("[invoice] openModal() fired");

    const v = getSelectedVariantId();
    if (v) $("invoiceVariantId").value = v;

    const errBox = $("invoiceError");
    if (errBox) errBox.hidden = true;

    $("invoiceModalOverlay").hidden = false;
    $("invoiceModal").hidden = false;
  }

  function closeModal() {
    $("invoiceModal").hidden = true;
    $("invoiceModalOverlay").hidden = true;
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("#invoiceRequestBtn")) openModal();
    if (e.target.closest("#invoiceModalOverlay")) closeModal();
    if (e.target.closest("#invoiceModalClose")) closeModal();
    if (e.target.closest("#invoiceCancelBtn")) closeModal();
  });

  document.addEventListener("submit", async (e) => {
    if (e.target?.id !== "invoiceForm") return;
    e.preventDefault();

    const submitBtn = $("invoiceSubmitBtn");
    const errBox = $("invoiceError");

    // Keep variant synced at submit time
    const v = getSelectedVariantId();
    if (v) $("invoiceVariantId").value = v;

    const formData = new FormData(e.target);

    const payload = {
  variant_id: $("invoiceVariantId").value,
  quantity: Number(formData.get("quantity") || 1),
  email: formData.get("email"),
  first_name: formData.get("first_name"),
  last_name: formData.get("last_name") || "",
  address1: formData.get("address1"),
  city: formData.get("city"),
  province: formData.get("province"),
  zip: formData.get("zip"),
  country: formData.get("country"),
  country_code: "US",
  source_url: window.location.href,
};


    console.log("[invoice] submitting payload", payload);

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent || "";
      submitBtn.textContent = "Generating…";
    }
    if (errBox) errBox.hidden = true;

    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || "Failed to create invoice.");

      if (data.invoice_url) {
        window.location.href = data.invoice_url;
        return;
      }

      throw new Error("No invoice URL returned.");
    } catch (err) {
      if (errBox) {
        errBox.hidden = false;
        errBox.textContent = err?.message || "Something went wrong.";
      }
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.originalText || "Generate";
      }
    }
  });
})();
